import { Button, LoadingOverlay, ScrollArea, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useEffect, useState } from 'react';

import { Customer, User } from '@e-origin/shared';

import { LeavePageNotification, StickyContainer } from '@components';
import { EditCustomerType } from '@enums';
import { useCustomer } from '@hooks/customer';
import { ExternalRestrictedUsers } from './ExternalRestrictedUsers';
import { useCustomerViewApiUserFormInitializer } from './useCustomerViewApiUserFormInitializer';

interface CustomerViewApiUserProps {
  handleSubmitCustomer(type: EditCustomerType, childForm: UseFormReturnType<any>): void;
  customerDetails: Customer;
  isCreate: boolean;
  customerId: string;
}

export const CustomerViewApiUser: React.FC<CustomerViewApiUserProps> = ({ customerDetails, handleSubmitCustomer, isCreate, customerId }) => {
  const { isLoading } = useCustomer(customerId);

  const externalUsers = (customerDetails?.externalUsers || []) as unknown as User[];
  const [externalUserList, setExternalUserList] = useState<{ value: string; label: string }[]>([]);

  const { form, buildFormValues } = useCustomerViewApiUserFormInitializer({ customerDetails });

  useEffect(() => {
    setExternalUserList(
      externalUsers.map((ext) => ({
        label: `${ext.firstName} ${ext.lastName}`,
        value: ext._id,
      })),
    );
    form.setValues(buildFormValues(customerDetails));
    form.resetDirty({} as any);
  }, [customerDetails]);

  const handleExternalUsersIds = (ids) => {
    form.setFieldValue('externalUsers', ids);
  };

  if (!customerDetails) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }
  return (
    <>
      <LeavePageNotification hasUnsavedChanges={form.isDirty()} />

      <ScrollArea h="100%" offsetScrollbars="y">
        <Stack mx="xl" mb="md">
          <Title order={5} fw={600}>
            Allowed external users
          </Title>

          <ExternalRestrictedUsers list={externalUserList} onUpdate={handleExternalUsersIds} />
        </Stack>

        <StickyContainer>
          <Button onClick={() => handleSubmitCustomer(EditCustomerType.API_USER, form)} type="submit" variant="filled" size="lg">
            {isCreate ? 'Create' : 'Save'}
          </Button>
        </StickyContainer>
      </ScrollArea>
    </>
  );
};
